import React, { useMemo } from 'react';
import { Button, Card, Col, Row, FormCheck, Modal, ListGroup } from 'react-bootstrap';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { InputFormFiled } from '../../../components/Common/FormikField/InputFormFiled';
import { Input } from 'reactstrap';
import toastAlert from '../../../js/Base/ToastAlert';
import 'react-datepicker/dist/react-datepicker.css';
import CloseIcon from '@mui/icons-material/Close';
import { createDocumentInfo, updateDocumentInfo } from '../../../api/projectApi';
import { GetSchema, company_name, project_name, document_no, number_text_required, document_name, string_required } from '../../../js/Base/ValidationSchema';

const DocumentSnInfoModal = ({ isModalOpen, handleClose, isUpdate, editData, reportIdList, submitEffect }) => {
  const userName = localStorage.getItem("user_email");
  const projectId = localStorage.getItem("project_id");
  const projectUuid = localStorage.getItem("project_uuid");

  const formSchema = GetSchema({
      company_name: company_name().nullable(),
      project_name: project_name().nullable(),
      document_no: document_no().nullable(),
      document_sn: number_text_required(0, 99).nullable(),
      document_name: document_name().nullable(),
      report_version: string_required(),
    });

  const initialValues = useMemo(() => ({
    id: isUpdate ? editData?.id ?? null : null,
    report_id: isUpdate
      ? editData?.report ?? ''
      : reportIdList?.[0]?.uuid ?? '',
    company_name: editData?.company_name ?? '',
    project_name: editData?.project_name ?? '',
    document_no: editData?.document_no ?? '',
    document_sn: editData?.document_sn ?? '',
    document_name: editData?.report_title ?? '',
    date_format: editData?.date_format ?? '0',
    report_version: editData?.report_version ?? '',
  }), [isUpdate, editData, reportIdList]);

  const dateFormatOnChange = (event, setFieldValue) => {
    setFieldValue('date_format', event.target.value);
  };

  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    setSubmitting(true);
    try {
      const payload = buildPayload(values);
      const api = isUpdate ? updateDocumentInfo : createDocumentInfo;
      const successMsg = isUpdate ? '更新成功' : '新增成功';
      const failMsg = isUpdate ? '更新失敗' : '新增失敗';

      const data = await api(payload);

      if (data.success) {
        toastAlert.autoClose(true).showSuccess(successMsg);
        submitEffect();
      } else {
        toastAlert.autoClose(true).showError(failMsg);
      }

    } catch (error) {
      toastAlert.autoClose(true).showError("發生錯誤，請稍後再試");
    } finally {
      handleClose();
      setSubmitting(false);
    }
  };

  const buildPayload = (values) => ({
    acct_email: userName,
    report_doc_info: {
      ...(isUpdate && { id: values.id }),
      project_id: projectId,
      project_uuid: projectUuid,
      report: values.report_id,
      workspace_no: values.workspace_no || '0',
      company_name: values.company_name,
      project_name: values.project_name,
      document_no: values.document_no,
      document_sn: values.document_sn,
      report_title: values.document_name,
      date_format: values.date_format || '0',
      report_version: values.report_version
    }
  });


  return (
    <>
      <Modal
        animation="true"
        style={{ zIndex: '8999' }}
        show={isModalOpen}
        onHide={() => {handleClose()}}
        className="ProjectManagement"
      >
        <Modal.Header>
          <Modal.Title style={{ fontSize: '16px', fontWeight: 'bold', }}>{!isUpdate ? '新增' : '編輯'}</Modal.Title>
        
          {/* 解決籃框問題，自訂MUI按鈕 */}
          <button
            onClick={handleClose}
            style={{
              background: 'transparent',
              border: 'none',
              cursor: 'pointer',
              padding: 0,
              marginLeft: 'auto'
            }}
          >
            <CloseIcon fontSize="medium" />
          </button>
        </Modal.Header>
        <Formik
          initialValues={initialValues}
          validationSchema={formSchema}
          onSubmit={handleSubmit}
          enableReinitialize={true}
        >
          {({ handleSubmit, resetForm, setFieldValue, isSubmitting, errors, touched, values }) => (
            <Form>
                <Modal.Body className="modal-body" style={{ paddingTop: '0px'}}>
                <Row>
                <Col md="12">
                    <p
                      style={{
                        fontSize: '12px',
                        color: '#323232',
                        fontWeight: 'bold',
                        marginTop: '20px',
                        marginBottom: '6px',
                      }}
                    >
                      報表ID
                    </p>

                    <Input
                      type="select"
                      value={values.report_id}
                      onChange={(e) => setFieldValue('report_id', e.target.value)}
                      id="report_id"
                      name="report_id"
                      disabled={isUpdate}
                      style={{ fontSize: '13px' }}
                    >
                      {reportIdList?.length ? (
                        reportIdList.map((report) => (
                          <option key={report.uuid} value={report.uuid}>
                            {`${report.source || ''} - ${report.cloud || ''} - ${report.display_name || ''}`}
                          </option>
                        ))
                      ) : (
                        <option value="">無資料</option>
                      )}
                    </Input>
                  </Col>
                    <Col md="12">
                    <InputFormFiled
                        title="客戶名稱"
                        className="input-field custom-select"
                        name="company_name"
                        type="text"
                        invalid={errors.company_name && touched.company_name}
                    />
                    </Col>
                    <Col md="12">
                    <InputFormFiled
                        title="專案名稱"
                        className="input-field custom-select"
                        name="project_name"
                        type="text"
                        invalid={errors.project_name && touched.project_name}
                    />
                    </Col>
                    <Col md="12">
                    <InputFormFiled
                        title="文件編號"
                        className="input-field custom-select"
                        name="document_no"
                        type="text"
                        invalid={errors.document_no && touched.document_no}
                    />
                    </Col>
                    <Col md="12">
                      <InputFormFiled
                          title="序號"
                          className="input-field custom-select"
                          name="document_sn"
                          type="text"
                          invalid={errors.document_sn && touched.document_sn}
                      />
                    </Col>
                    <Col md="12">
                    <InputFormFiled
                        title="報告標題"
                        className="input-field custom-select"
                        name="document_name"
                        type="text"
                        invalid={errors.document_name && touched.document_name}
                    />
                    </Col>
                    <Col md="12">
                    <InputFormFiled
                        title="報告文件版本"
                        className="input-field custom-select"
                        name="report_version"
                        type="text"
                        invalid={errors.report_version && touched.report_version}
                    />
                    </Col>
                    <Col md="12">
                      <p
                        style={{
                          fontSize: '12px',
                          color: '#323232',
                          fontWeight: 'bold',
                          marginTop: '20px',
                          marginBottom: '6px',
                        }}
                      >
                        日期格式
                      </p>
                      <Input
                        type="select"
                        style={{ fontSize: '13px' }}
                        value={values.date_format}
                        onChange={(event) => dateFormatOnChange(event, setFieldValue)}
                        id="date_format"
                        name="date_format"
                      >
                        <option key={0} value={'0'}>民國年</option>
                        <option key={1} value={'1'}>西元年</option>
                      </Input>
                    </Col>
                </Row>
                </Modal.Body>
                <Modal.Footer className="modal-footer">
                <Button
                    type="button"
                    className="btn btn-cancel"
                    onClick={() => {
                    resetForm();
                    handleClose();
                    }}
                >
                    取消
                </Button>
                <Button type="submit" className="btn btn-custom" disabled={isSubmitting} >
                    確認
                </Button>
                </Modal.Footer>
            </Form>
          )}
        </Formik>
      </Modal>
    </>
  );
};

export default DocumentSnInfoModal;
